import { render, staticRenderFns } from "./FeedNew.vue?vue&type=template&id=8ecf6e90&"
import script from "./FeedNew.vue?vue&type=script&lang=js&"
export * from "./FeedNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports